import { Component, input, model } from '@angular/core';
import { LucideDynamicIcon } from '@lucide/angular';
import { NgpButton } from 'ng-primitives/button';
import { JoiiIcon } from '../../icons/lucide/icon';

export type InlineButtonVariant = 'primary' | 'secondary' | 'alert';
export type InlineButtonSize = 'sm' | 'md' | 'lg';
export type InlineButtonState = 'active';
export type InlineButtonShape = 'rounded' | 'circle';

@Component({
  selector: 'button[joii-inline-button]',
  imports: [LucideDynamicIcon],
  hostDirectives: [{ directive: NgpButton, inputs: ['disabled'] }],
  template: `
    @if (prefixIcon(); as prefixIcon) {
      <svg [lucideIcon]="prefixIcon" [strokeWidth]="2" />
    }
    <ng-content select="[slot=prefix]" />
    <span data-content>
      <ng-content></ng-content>
    </span>
    @if (suffixIcon(); as suffixIcon) {
      <svg [lucideIcon]="suffixIcon" [strokeWidth]="2" />
    }
    <ng-content select="[slot=suffix]" />
  `,
  styleUrl: './inline-button.component.css',
  host: {
    '[attr.data-size]': 'size()',
    '[attr.data-variant]': 'variant()',
    '[attr.disabled]': 'disabled()',
    '[attr.data-state-active]': 'active()',
    '[attr.data-full-width]': 'fullWidth()',
    '[attr.data-transparent]': 'transparent()',
    '[attr.data-borderless]': 'borderless()',
    '[attr.data-shape]': 'shape()',
    '[attr.icon-only]': 'iconOnly()',
  },
})
export class InlineButtonComponent {
  variant = input<InlineButtonVariant>('primary');
  size = input<InlineButtonSize>('md');
  transparent = input<boolean>(false);
  borderless = input<boolean>(false);
  fullWidth = input<boolean>(false);
  shape = input<InlineButtonShape>('rounded');
  prefixIcon = input<JoiiIcon | undefined>(undefined);
  suffixIcon = input<JoiiIcon | undefined>(undefined);
  iconOnly = input<boolean>(false);
  type = input<'button' | 'submit' | 'reset'>('button');
  disabled = input(false);
  active = model<boolean>(false);
}
